<template>
  <validation-observer ref="SubTaskForm" #default="{ invalid }">
    <b-form @submit.prevent="formSubmitted()">
      <b-row>
        <b-col md="12">
          <b-form-group label="Title" label-for="task_title">
            <validation-provider
              #default="{ errors }"
              name="Title"
              vid="Title"
              rules="required"
            >
              <b-form-input
                id="task_title"
                placeholder="Title"
                required
                v-model="subtask.title"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col md="6">
          <b-form-group label="Start Date" label-for="start_date">
            <validation-provider
              #default="{ errors }"
              name="Start Date"
              vid="Start Date"
              rules="required"
            >
              <b-form-datepicker
                
                id="start_date"
                class="mb-1"
                v-model="subtask.startDate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="6">
          <b-form-group label="End Date" label-for="end_date">
            <validation-provider
              #default="{ errors }"
              name="End Date"
              vid="End Date"
              rules="required"
            >
              <b-form-datepicker
                :min="subtask.startDate || currentDate"
                id="end_date"
                placeholder="Choose a date"
                v-model="subtask.endDate"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group label="Assignee(s)" label-for="assignee">
            <validation-provider
              #default="{ errors }"
              name="Assignee"
              vid="Assignee"
              rules="required"
            >
              <b-form-select
                v-model="subtask.assignee"
                :options="assignee_options"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <!-- <b-col md="4">
          <b-form-group label="Priority" label-for="priority">
            <b-form-select v-model="subtask.priority" :options="priorityOptions" required />
          </b-form-group>
        </b-col> -->
        <b-col md="4">
          <b-form-group label="Status" label-for="status">
            <b-form-select
              v-model="subtask.status"
              :options="statusOptions"
              required
            />
          </b-form-group>
        </b-col>

        <b-col md="12">
          <b-form-group label="Comment" label-for="task_description">
            <b-form-textarea
              id="task_description"
              placeholder="Comment"
              rows="3"
              v-model="subtask.description"
            />
          </b-form-group>
        </b-col>

        <!-- submit and reset -->
        <b-col
          md="12"
          v-if="actionType !== 'view'"
          class="d-flex justify-content-between"
        >
          <b-button type="button" @click="formSubmitted" variant="primary"
            >Submit</b-button
          >
        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BForm,
  BFormInput,
  BFormTextarea,
  BFormSelect,
  BFormDatepicker,
  BFormGroup,
  BButton,
  BSpinner,
} from "bootstrap-vue";
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { customError, customSwal, customLoader } from "@/libs/customFn";
import "@/libs/customValidation";

export default {
  name: "AddProject",
  components: {
    BRow,
    BCol,
    BForm,
    BFormInput,
    BFormTextarea,
    BFormSelect,
    BFormDatepicker,
    BFormGroup,
    BButton,
    BSpinner,
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    subtask: {
      type: Object,
      default: () => ({}),
    },
    actionType: {
      type: String,
      default: "view",
    },
  },

  data() {
    return {
      assetCode: "",
      task_title: "Title 1",
      task_description: "Task description will appear here",
      task_start_date: "2024-06-16",
      task_end_date: "2024-06-25",
      purchaseDate: null,
      currentDate: new Date().toISOString().split("T")[0],
      lifeEndDate: null,
      maintainanceDate: null,
      location: "",
      assignee_selected: 1,
      priority_selected: 2,
      status_selected: 2,
      costPerHour: 0,
      priorityOptions: [
        { value: "NOTSPECIFIED", text: "Not Specified" },
        { value: "LOW", text: "Low" },
        { value: "MEDIUM", text: "Medium" },
        { value: "HIGH", text: "High" },
      ],
      statusOptions: [
        { value: "NOTSTARTED", text: "Not Started" },
        { value: "INPROGRESS", text: "In Progress" },
        { value: "ONHOLD", text: "On Hold" },
        { value: "COMPLETED", text: "Completed" },
      ],

      assignee_options: [],
    };
  },

  methods: {
    ...mapActions("projectModule", [
      "getProjectAssigneesAction",
      "getProjectSubTasksAction",
      "addProjectSubTaskAction",
      "updateProjectSubTaskAction",
    ]),

    resetForm() {
      (this.subtask.title = null),
        (this.subtask.description = null),
        (this.subtask.status = null),
        (this.subtask.assignee = null),
        (this.subtask.startDate = null),
        (this.subtask.endDate = null);
    },

    async formSubmitted() {
      let isValid = await this.$refs.SubTaskForm.validate();
      if (isValid) {
        // const formattedStartDate = this.subtask.startDate
        //   ? new Date(this.subtask.startDate).toISOString()
        //   : null;
        // const formattedEndDate = this.subtask.endDate
        //   ? new Date(this.subtask.endDate).toISOString()
        //   : null;

        let payload = {
          projectId: this.subtask.projectId,
          ...this.subtask,
          tasksId: this.subtask.tasksId,
          assigneeName: this.assigneeName,
          startDate: this.subtask.startDate,
          endDate: this.subtask.endDate,
        };

        if (this.actionType === "add") {
          let loader = customLoader(
            `Please wait while the sub task is being added`
          );
          this.addProjectSubTaskAction(payload)
            .then((res) => {
              if (res.success) {
                customSwal("You have successfully added the Task!");
                this.$emit("taskAdded");
                Swal.fire({
                  title: "Added!",
                  text: "You have successfully added the Task!",
                  icon: "success",
                  customClass: {
                    confirmButton: "btn btn-success",
                  },
                });

                // console.log("tasksssssssss", this.subtask);
                // this.getProjectSubTasksAction({
                //   projectid: this.subtask.projectId,
                //   taskid: this.subtask.tasksId,
                // })
                //   .then((response) => {
                //     this.projectName = this.subtasks.map(
                //       (item) => item.projectName
                //     )[0];
                //     this.filteredSubtasks = this.subtasks; // Initialize filtered tasks
                //     this.totalRows = this.filteredSubtasks.length; // Set total rows
                //   })
                //   .catch((response) => {
                //     console.log(response);
                //   });

                this.resetForm();
                loader.close();
                this.success();
              //  console.log("taskssssss4567890-sss", this.subtask);
                // this.getProjectSubTasksAction();
                this.$refs.addProjectModal.hide();
              } else {
                customError(res.message);
              }
              loader.close();
            })
            .catch((error) => {
              loader.close();
              customError(error.response.data);
            });
        } else {
          let loader = customLoader(
            `Please wait while the sub task is being updated`
          );
          this.updateProjectSubTaskAction(payload)
            .then((res) => {
              if (res.success) {
                customSwal("You have successfully updated the Task!");
                this.$emit("taskUpdated");

                this.resetForm();
                this.getProjectSubTasksAction();
                this.$refs.SubTaskForm.hide();
              } else {
                customError(res.message);
              }
              loader.close();
            })
            .catch((error) => {
              loader.close();
              customError(error.response.data);
            });
        }
      }
    },
  },
  computed: {
    ...mapGetters("projectModule", {
      assignees: "assignees",
      loading: "loading",
    }),
    assigneeName() {
      const assignee = this.assignee_options.find(
        (option) => option.value === this.subtask.assignee
      );
      return assignee ? assignee.text : "";
    },
  },

  async mounted() {
    //console.log("🚀 ~ mounted ~ subtask:", this.actionType, this.subtask);
    await this.getProjectAssigneesAction().then(() => {
      this.assignee_options = this.assignees.map((assignee) => ({
        value: assignee.id,
        text: `${assignee.firstName} ${assignee.lastName}`,
      }));
    });
  },
};
</script>
